export class JobCandidateStatus {
    id: number;
    description: string;
    isNoShowRejectionReasonEligible: boolean;

    private constructor(
        id: number,
        description: string,
        isNoShowRejectionReasonEligible: boolean
    ) {
        this.id = id;
        this.description = description;
        this.isNoShowRejectionReasonEligible = isNoShowRejectionReasonEligible;
    }

    public static New = new JobCandidateStatus(10, "New", false);
    public static Qualifying = new JobCandidateStatus(20, "Qualifying", false);
    public static Review = new JobCandidateStatus(25, "Review", false);
    public static Submitted = new JobCandidateStatus(30, "Submitted", false);
    public static Interviewing = new JobCandidateStatus(
        40,
        "Interviewing",
        true
    );
    public static Offered = new JobCandidateStatus(45, "Offered", false);
    public static Rejected = new JobCandidateStatus(50, "Rejected", false);
    public static Hired = new JobCandidateStatus(60, "Hired", true);

    public static asArray = () => [
        JobCandidateStatus.New,
        JobCandidateStatus.Qualifying,
        JobCandidateStatus.Review,
        JobCandidateStatus.Submitted,
        JobCandidateStatus.Interviewing,
        JobCandidateStatus.Offered,
        JobCandidateStatus.Rejected,
        JobCandidateStatus.Hired,
    ];

    public static fromId = (id: number) => {
        if (id === undefined) return undefined;
        const status = JobCandidateStatus.asArray().find(s => s.id === id);
        return status;
    };

    public static fromName = (description: string) => {
        if (description === undefined) return undefined;
        const status = JobCandidateStatus.asArray().find(
            s => s.description === description
        );
        return status;
    };
}
